import { Constants, WebFormMode } from '@dx-ui/dx-common/src';
import { useEffect, useMemo, useState } from 'react';
import {
  Loading,
  linkToRecord,
  useDataProvider,
  useNotify,
  useRedirect,
} from 'react-admin';
import { useRouteMatch } from 'react-router-dom';
import {
  DocumentServiceFactory,
  WaybillService,
  WaybillServiceCreator,
} from '../../services';

const WayBillCreate = (props) => {
  const dataProvider = useDataProvider();
  const redirect = useRedirect();
  const notify = useNotify();

  const [data, setData] = useState<any>(undefined);
  const [loading, setLoading] = useState(false);

  const match: any = useRouteMatch();
  const { recipientId } = match.params;

  const waybillService: WaybillService = useMemo(
    () =>
      DocumentServiceFactory.create(
        WaybillServiceCreator,
        dataProvider
      ) as WaybillService,
    [dataProvider]
  );

  useEffect(() => {
    const createNewWaybill = async () => {
      setLoading(true);
      try {
        const nodeId: string | undefined = await waybillService.createNew(
          recipientId
        );
        setData(nodeId);
        setLoading(false);
        redirect(
          `/${linkToRecord(Constants.RESOURCE_WEBWAYBILL, nodeId)}`,
          undefined, // basePath
          undefined, // id
          undefined, // data
          { redirectMode: WebFormMode.SCRATCH_WAYBILL } // state
        );
      } catch (e) {
        notify(
          'dxMessages.dashboard.OnErrorContactSupport',
          'error',
          { error: e },
          true
        );
        setLoading(false);
      }
    };
    if (!data) {
      createNewWaybill();
    }
  }, [data, waybillService, notify, recipientId, redirect]);
  if (loading) {
    return <Loading />;
  } else return null;
};

export default WayBillCreate;
